// extracted by mini-css-extract-plugin
export var body = "Faq-module--body--a0aaa";
export var icon = "Faq-module--icon--4a925";
export var item = "Faq-module--item--dfaa8";
export var question = "Faq-module--question--55b85";
export var questionText = "Faq-module--questionText--7f42b";
export var wrapper = "Faq-module--wrapper--04937";